import React from "react";
import * as Sentry from '@sentry/react';
import { render } from "react-dom";
import PickupRoutes from "../routes/PickupRoutes";

// Styles
import "jquery/dist/jquery.min.js";
import "bootstrap/scss/bootstrap";
import "bootstrap/dist/js/bootstrap.min.js";
import "antd/dist/antd.css";
import "../stylesheet/App";

document.addEventListener("DOMContentLoaded", () => {
  if(process.env.NODE_ENV === 'production') {
    Sentry.init({
      dsn: "https://b254172a0038c55795ec4962e87a6155@sentry.mijora.dev/16",
      integrations: [
        new Sentry.BrowserTracing(),
      ],
      tracesSampleRate: 1.0,
    });
  }

  render(
    <PickupRoutes />,
    document.body.appendChild(document.createElement("div"))
  );
});
